import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { CommunicationManagerService } from './communication-manager.service';
import { formatDate } from '@angular/common';
import { Observable } from 'rxjs';
import { MonthlyBankAccountBalanceLite } from '../models/monthly-bank-account-balance.model';

@Injectable({
  providedIn: 'root',
})
export class MonthlyAccountBalanceService {
  constructor(
    private cm: CommunicationManagerService,
    @Inject(LOCALE_ID) private locale: string
  ) {}

  getMonthlyAccountBalancesForCompanyAndMonth(
    companyId: string,
    month: Date
  ): Observable<Array<MonthlyBankAccountBalanceLite>> {
    // console.log(month);
    const date = formatDate(month, 'YYYY-MM-dd', this.locale);

    return this.cm.get(`monthlyAccountBalance/all/${date}`, [
      { headerName: 'companyId', headerValue: companyId },
    ]) as Observable<Array<MonthlyBankAccountBalanceLite>>;
  }
}
